angular.module('SpidApp')

.factory('_', function () {
	return _
})

.controller('AppController',
		['$state', 'USER_CONFIG', 'BASE_PUBLIC_URL', '$scope', 'LoginService', '$rootScope', '$localStorage', 'Device', '_', 'AgencyService', 'ConfigService', 'User', 'Toaster', 'Conversion', 'SyncRunner', 'RouteSupervisor',
function ($state,   USER_CONFIG,   BASE_PUBLIC_URL,   $scope,   LoginService,   $rootScope,   $localStorage,   Device,   _,   AgencyService,   ConfigService,   User,   Toaster,   Conversion,   SyncRunner,   RouteSupervisor) {
	$scope.img = BASE_PUBLIC_URL + "/images/laposte_angular.png"
	
	$scope.$on('unauthorizedResponse', function () {
		LoginService.logout().then(function () {
			$state.go('login')
		})
	})
	
	$scope.getDisplayName = function (role) {
		return User.getDisplayName(role)
	}
	
	$scope.user = new User($localStorage.user)

	$scope.refreshDeviceStatus = function ($event) {
		if ($event) {
			$event.preventDefault()
			$event.stopPropagation()
		}
		$scope.devices = Device.getDevices()

		Device.getUnionStatus().then(function (u) {
			var unionStatus = u

			if (unionStatus === 'OK') {
				$scope.unionStatusClass = Device.goodIconColorClass
			} else {
				$scope.unionStatusClass = Device.badIconColorClass
			}
		})
	}
	$scope.refreshDeviceStatus()

	$scope.colors = {
		  GUICHETIER  : USER_CONFIG.guichetier.color
		, RECEVEUR    : USER_CONFIG.receveur.color
		, SUPERVISEUR : USER_CONFIG.superviseur.color
	}
	$scope.setActiveRole = function (role) {
		$scope.user.activeRole = role
		$localStorage.user.activeRole = role
		
		$scope.roleColorClass = $scope.colors[role]
		
		Toaster.show('Vous êtes connecté en tant que <b>'+User.getDisplayName(role)+'</b>')
		
		$scope.$broadcast('changeRoleEvent', {'role':role});
	}
	$scope.setActiveRole($scope.user.activeRole)

	$scope.fetchAgency = function () {
		return ConfigService.all().then(function (configs) {
			$rootScope.configs = configs
		}).then(function () {
			return AgencyService.find($rootScope.configs.agencyId).then(function (agency) {
				$scope.agency = agency;
			})
		})
	}

	$scope.appControllerOver = $scope.fetchAgency()
	$scope.restoreAgency = function () {
		return $scope.fetchAgency().then(function () {
			Toaster.warning("L'agence a été rechargée")
		})
	}

	$scope.$on('changeRoleEvent', function(event, args) {
		RouteSupervisor.check(event, args.role);
	});
}])
